import apiClient from "./client.js";

/**
 * Fetch an incident's postmortem. Rejects with a 404 if none exists yet.
 * @param {string} incidentId
 */
export async function fetchPostmortem(incidentId) {
  const res = await apiClient.get(`/incidents/${incidentId}/postmortem`);
  return res.data.data;
}

/**
 * Create a postmortem for a resolved incident.
 * @param {string} incidentId
 * @param {object} [body]
 */
export async function createPostmortem(incidentId, body = {}) {
  const res = await apiClient.post(`/incidents/${incidentId}/postmortem`, body);
  return res.data.data;
}

/**
 * Update a postmortem's content and/or status.
 * @param {string} incidentId
 * @param {object} body
 */
export async function updatePostmortem(incidentId, body) {
  const res = await apiClient.patch(`/incidents/${incidentId}/postmortem`, body);
  return res.data.data;
}

/**
 * Add a corrective action to a postmortem.
 * @param {string} incidentId
 * @param {{ title: string, owner_id?: string, due_date?: string }} body
 */
export async function addCorrectiveAction(incidentId, body) {
  const res = await apiClient.post(`/incidents/${incidentId}/postmortem/actions`, body);
  return res.data.data;
}

/**
 * Update a corrective action.
 * @param {string} incidentId
 * @param {string} actionId
 * @param {object} body
 */
export async function updateCorrectiveAction(incidentId, actionId, body) {
  const res = await apiClient.patch(
    `/incidents/${incidentId}/postmortem/actions/${actionId}`,
    body
  );
  return res.data.data;
}

/**
 * Remove a corrective action.
 * @param {string} incidentId
 * @param {string} actionId
 */
export async function removeCorrectiveAction(incidentId, actionId) {
  const res = await apiClient.delete(
    `/incidents/${incidentId}/postmortem/actions/${actionId}`
  );
  return res.data.data;
}
